import { z } from "zod";

// Skema untuk data "Number of Reservations by Source"
const ReservationBySourceDataSchemaV4 = z.array(
    z.object({
        name: z.string().nullable(),
        color: z.string().nullable(),
        total: z.number(),
    })
);

// Skema untuk response "Number of Reservations by Source"
const ReservationBySourceResponseV4 = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: ReservationBySourceDataSchemaV4,
});

// Skema untuk data "Revenue by Source"
const RevenueBySourceDataSchemaV4 = z.array(
    z.object({
        name: z.string().nullable(),
        color: z.string().nullable(),
        revenue: z.coerce.number(), // Menggunakan coerce untuk memastikan tipe number
    })
);

// Skema untuk response "Revenue by Source"
const RevenueBySourceResponseV4 = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: RevenueBySourceDataSchemaV4,
});


// Ekspor tipe data yang di-infer dari skema
export type ReservationBySourceDataType = z.infer<typeof ReservationBySourceDataSchemaV4>;
export type RevenueBySourceDataType = z.infer<typeof RevenueBySourceDataSchemaV4>;

export {
    ReservationBySourceResponseV4,
    RevenueBySourceResponseV4,
};